/** @type {import('next-seo').DefaultSeoProps} */
const defaultSEOConfig = {
  title: 'Web3Inbox waitlist',
  titleTemplate: '%s | Web3Inbox waitlist',
  defaultTitle: 'Web3Inbox waitlist',
  description: 'Get on the Web3Inbox waitlist now',
  canonical: 'https://minisite-web3inbox-walletconnect1.vercel.app/',
  openGraph: {
    url: 'https://minisite-web3inbox-walletconnect1.vercel.app/',
    title: 'Web3Inbox waitlist',
    description: 'Get on the Web3Inbox waitlist now',
    images: [
      {
        url: 'https://minisite-web3inbox-walletconnect1.vercel.app/banner.png',
        alt: 'Web3Inbox waitlist',
      },
    ],
    site_name: 'Web3Inbox waitlist',
  },
  twitter: {
    handle: '@WalletConnect',
    cardType: 'summary_large_image',
  },
};

export default defaultSEOConfig;
